module.exports = __webpack_public_path__ + "static/media/CiBlock_logo.dc03e331.png";